import { Box, createStyles, makeStyles, Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      justifyContent: "space-between",
      width: 40,
    },
    dot: {
      minWidth: 8,
      width: 8,
      height: 8,
      borderRadius: 999,
      minHeight: 8,
      backgroundColor: "rgba(255, 255, 255, 0.4)",

      transition: "background-color .18s",

      animation: "$dotFlashing 1s infinite linear alternate",
    },
    dot1: {
      animationDelay: ".0s",
    },
    dot2: {
      animationDelay: ".33s",
    },
    dot3: {
      animationDelay: ".66s",
    },
    "@keyframes dotFlashing": {
      "0%": {
        backgroundColor: "rgba(255, 255, 255, 0.4)",
      },
      "50%": {
        backgroundColor: "rgba(255, 255, 255, 0.8)",
      },
      "100%": {
        backgroundColor: "rgba(255, 255, 255, 1)",
      },
    },
  }),
);

export const Loader = () => {
  const classes = useStyles();
  return (
    <Box display="flex" flex={1} justifyContent="center" alignItems="center">
      <Box className={classes.root}>
        <Box className={`${classes.dot} ${classes.dot1}`} />
        <Box className={`${classes.dot} ${classes.dot2}`} />
        <Box className={`${classes.dot} ${classes.dot3}`} />
      </Box>
    </Box>
  );
};
